// import React, { useRef } from "react";

// function ClientModal({ client, onClose }) {
//   const modalRef = useRef(null);

//   const handleBackdropClick = (e) => {
//     if (modalRef.current && !modalRef.current.contains(e.target)) {
//       onClose();
//     }
//   };

//   return (
//     <div
//       className="fixed inset-0 bg-black/60 backdrop-blur-md z-50 flex items-center justify-center px-2 sm:px-4"
//       onClick={handleBackdropClick}
//     >
//       <div
//         ref={modalRef}
//         className="bg-white/10 backdrop-blur-xl border border-white/20 p-6 sm:p-7 rounded-2xl w-full max-w-lg max-h-[90vh] overflow-y-auto shadow-2xl relative text-white"
//       >
//         {/* Close Button */}
//         <button
//           onClick={onClose}
//           className="absolute top-3 right-3 text-2xl font-bold text-white/70 hover:text-white transition"
//         >
//           &times;
//         </button>

//         {/* Title */}
//         <h3 className="text-2xl sm:text-3xl font-semibold mb-6 text-center drop-shadow-lg">
//           {client.name} Products
//         </h3>

//         {/* Product List */}
//         <div className="space-y-5">
//           {client.products.map((product, index) => (
//             <div
//               key={index}
//               className="flex flex-col sm:flex-row items-center gap-5 border border-white/25 bg-white/10 backdrop-blur-lg p-4 rounded-xl hover:scale-[1.03] hover:bg-white/20 transition duration-300 shadow-lg"
//             >
//               <img
//                 src={product.image}
//                 alt={product.name}
//                 className="w-32 h-32 sm:w-40 sm:h-40 object-cover rounded-xl border border-white/20 shadow-md"
//               />
//               <div className="flex-1 text-center sm:text-left">
//                 <p className="text-lg font-semibold text-white drop-shadow-lg">
//                   {product.name}
//                 </p>
//                 <p classname="text-sm text-gray-200/80">{product.price}</p>
//               </div>

//               <a
//                 href={product.link}
//                 target="_blank"
//                 rel="noopener noreferrer"
//                 className="mt-2 sm:mt-0 bg-yellow-500 text-black font-semibold px-4 py-2 rounded-lg shadow-md hover:bg-yellow-400 hover:scale-105 transition duration-300"
//               >
//                 Buy Now
//               </a>
//             </div>
//           ))}
//         </div>
//       </div>
//     </div>
//   );
// }

// export default ClientModal;

import React, { useRef } from "react";

function ClientModal({ client, onClose }) {
  const modalRef = useRef(null);

  const handleBackdropClick = (e) => {
    if (modalRef.current && !modalRef.current.contains(e.target)) {
      onClose();
    }
  };

  return (
    <div
      className="fixed inset-0 bg-black/50 z-50 flex items-center justify-center px-2 sm:px-4"
      onClick={handleBackdropClick}
    >
      <div
        ref={modalRef}
        className="bg-secondary-color border border-white/20 p-6 sm:p-7 rounded-2xl w-full max-w-lg max-h-[90vh] overflow-y-auto shadow-xl relative text-white"
      >
        {/* Close Button */}
        <button
          onClick={onClose}
          className="absolute top-3 right-3 text-2xl font-bold text-white/80 hover:text-white transition"
        >
          &times;
        </button>

        {/* Title */}
        <h3 className="text-2xl text-primary-color sm:text-3xl font-bold mb-6 text-center">
          {client.name} Products
        </h3>

        {/* Product List */}
        <div className="space-y-5">
          {client.products.map((product, index) => (
            <div
              key={index}
              className="flex flex-col sm:flex-row items-center gap-5 border border-white/20 bg-black/10 p-4 rounded-xl hover:scale-[1.03] hover:bg-black/20 transition duration-300 shadow-lg"
            >
              <img
                src={product.image}
                alt={product.name}
                className="w-32 h-32 sm:w-40 sm:h-40 object-cover rounded-xl border border-white/20 shadow-md"
              />

              <div className="flex-1 text-center sm:text-left">
                <p className="text-lg font-semibold text-white">
                  {product.name}
                </p>
                <p className="text-sm text-gray-200/90">{product.price}</p>
              </div>

              <a
                href={product.link}
                target="_blank"
                rel="noopener noreferrer"
                className="mt-2 sm:mt-0 bg-primary-color text-secondary-color font-semibold px-4 py-2 rounded-lg shadow-md hover:bg-secondary-color hover:text-primary-color hover:scale-105 transition duration-300"
              >
                Buy Now
              </a>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default ClientModal;
